<style scoped>
      .title {
        font-size: 20px;
    }
    hr {
        border: 1px solid #f69f00;
    }
</style>

<template>
  <div>
    <v-card>
      <v-list two-line subheader>
        <v-subheader class="title">KALKULATOR INSTALACJI FOTOWOLTAICZNEJ</v-subheader>
      </v-list>
      <v-container>
      <v-text-field label="Roczny koszt energii [zł]" type="number" v-model="koszt" ></v-text-field>
      <v-text-field label="Roczne zużycie energii [kWh]" type="number" v-model="koszt" ></v-text-field>
      <v-text-field label="Moc istalacji [kW]" type="number" v-model="moc" ></v-text-field>
      <hr>
      <v-text-field label="E-mail klienta" type="email" v-model="moc" ></v-text-field>
      <v-btn >Wyślij</v-btn>
      </v-container>
    </v-card>
    <div class="overlay" v-if="!ready">
      <div class="flex-spinner">
        <v-progress-circular :size="200" :width="7" indeterminate color="amber"></v-progress-circular>
      </div> 
    </div>
  </div>
</template>

<script>

import Item from "@/models/Item";

export default {
  mounted () {
    this.$auth.check()
    .then(user => { })
    .catch(err => {
      console.log(err)
    })

    // retrieve messaging token.
    // only for production, you have to register the service-worker.

    // this.$store.state.messaging.getToken()
    //     .then((token) => {
    //         this.token = token
    //     })
  },
  firebase () {
    return {
      data: {
        source: this.$myDatabase.child("Solarspot"),
        readyCallback: () => {
          this.ready = true
        }
      }
    };
  },
  data () {
    return {
      token: "",
      Item: new Item(this.$myDatabase.child('item')).init(),
      ready: false,
      koszt: "",
      zuzycie: "",
      moc: ""
      
    }
  },
  methods: {
    addItem () {
      this.$firebaseRefs.data.onDisconnect().cancel()
      this.Item.push()
      this.Item.name = ""
    },
    deleteItem (key) {
      this.Item.remove(key);
    }
  }
};
</script>



// WEBPACK FOOTER //
// App.vue?5591dfed